"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._spaceOrComma = exports._comma = exports._space = exports._or = exports._optionalGroup = exports._group = exports._angle = exports._percentage = exports._number = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

// https://developer.mozilla.org/en-US/docs/Web/CSS/number
var _number = '[+-]?\\d*(?:\\.\\d+)?(?:e[+-]?\\d+)?'; // https://developer.mozilla.org/en-US/docs/Web/CSS/percentage

exports._number = _number;

var _percentage = "".concat(_number, "%"); // https://developer.mozilla.org/en-US/docs/Web/CSS/angle


exports._percentage = _percentage;

var _angle = "".concat(_number, "(?:deg|grad|rad|turn)?"); // Helper functions to construct complex regular expressions:


exports._angle = _angle;

var _group = function _group(arr, captureGroupName) {
  return [captureGroupName != null ? "(?<".concat(captureGroupName, ">") : '(?:'].concat((0, _toConsumableArray2.default)(arr), [')']).join('');
};

exports._group = _group;

var _optionalGroup = function _optionalGroup(arr, captureGroupName) {
  return "".concat(_group(arr, captureGroupName), "?");
};

exports._optionalGroup = _optionalGroup;

var _or = function _or(arr, captureGroupName) {
  return [captureGroupName != null ? "(?<".concat(captureGroupName, ">") : '(?:', // group start
  arr.join('|'), ')'].join('');
};

exports._or = _or;
var _space = '\\s';
exports._space = _space;
var _comma = '\\s?,\\s?';
exports._comma = _comma;

var _spaceOrComma = _or([_space, _comma]);

exports._spaceOrComma = _spaceOrComma;